<template>
    <div v-if="show_item === true" class="quiz__campaign__endpoint-startagain">
        <h2 class="quiz__campaign__endpoint-title">{{ content.title }}</h2>
        <a v-if="article_content !== undefined && article_content.cover_image !== null" :href="campaign.links.start" class="quiz__campaign__endpoint-button quiz__campaign__endpoint-button-primary">
            <img v-if="article_content.cover_image !== null" :src="article_content.cover_image.url" :alt="article_content.cover_image.alt_text" />
            <span class="link-text" v-if="article_content" v-html="article_content.content"></span>
        </a>
        <a v-else :href="campaign.links.start" class="quiz__campaign__endpoint-button quiz__campaign__endpoint-button-primary">
            <span class="link-text" v-if="article_content !== undefined" v-html="article_content.content"></span>
        </a>
    </div>
</template>
<script>
export default {
    props: ['campaign','content'],
    mounted() {
        if( this.content.data !== null )
        {
            this.article_content = this.content.data;
        }
        this.show_item = this.showBlock();
    },
    methods: {
        showBlock() {
            if (
                this.content.title !== null
                && this.article_content !== null
            ) {
                return true;
            }
            else return false;
        }
    },
    data() {
        return {
            article_content: null,
            show_item: false
        }

    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/start-again.vue